import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-chat-smile-icon',
  templateUrl: './communication-chat-smile.component.html'
})
export class CommunicationChatSmileComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
